import { createContext } from 'react'

const ExperimentContext = createContext<Partial<Record<string, string>>>({})
ExperimentContext.displayName = 'ExperimentContext'

export default ExperimentContext
